
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.3 19.4l-.3.5-4.7 1-.3-.3L2 16l.4-.4 3.9 3.8zM18.9 6.9l-3.8-3.8 1.4-1.4c.8-.8 2.1-.8 2.9 0l1 1c.8.7.8 2 0 2.8l-1.5 1.4zM7.7 18.1l-3.8-3.9 10-10L17.8 8 7.7 18.1z"}})])
          )
        }
      }
    